module.exports = __webpack_public_path__ + "static/media/11NEPAD2.d8e721e8.jpg";